export class TwoWayMapping {
    private readonly reverseMap: Record<string, string>;

    private readonly map: Record<string, string>;

    constructor(map: Record<string, string>) {
        this.map = map;
        this.reverseMap = {};

        Object.keys(map).forEach(key => {
            const value = map[key];
            this.reverseMap[value] = key;
        });
    }

    public find(item: string) {
        return this.map[item];
    }

    public findReverse(item: string) {
        return this.reverseMap[item];
    }
}
